<template>
  <div class="ManageOwner px-4">
    <h2 class="main-title">
      {{ $route.query.id ? "Izmeni vlasnika" : "Dodaj vlasnika" }}
    </h2>
    <div class="main-container">
      <v-card class="reset-password-container" elevation="0">
        <v-form
          class="my-form-container-new-owner"
          ref="myInfoForm"
          v-model="validForm"
          lazy-validation
        >
          <div>
            <v-text-field
              :label="lang == 'en' ? 'Name' : 'Ime Vlasnika'"
              v-model="ownerInfo.name"
              @keyup.enter="ManageOwner()"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Surname' : 'Prezime Vlasnika'"
              v-model="ownerInfo.surname"
              @keyup.enter="ManageOwner()"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Mobile Phone' : 'Mobilni Telefon'"
              v-model="ownerInfo.mobilePhone"
              @keyup.enter="ManageOwner()"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Phone' : 'Telefon'"
              v-model="ownerInfo.phone"
              @keyup.enter="ManageOwner()"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Broj LK' : 'Broj lične karte'"
              v-model="ownerInfo.lk"
              @keyup.enter="ManageOwner()"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'JMBG' : 'JMBG'"
              v-model="ownerInfo.jmbg"
              @keyup.enter="ManageOwner()"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'Address' : 'Adresa'"
              v-model="ownerInfo.address"
              @keyup.enter="ManageOwner()"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              :label="lang == 'en' ? 'E-mail' : 'E-mail'"
              v-model="ownerInfo.email"
              @keyup.enter="ManageOwner()"
              :rules="rules.required"
              outlined
              dense
            ></v-text-field>
            <div>
              <v-btn
                elevation="0"
                block
                color="text--white teal darken-2"
                @click="ManageOwner()"
              >
                {{ lang == "en" ? "ADD" : "SAČUVAJ" }}
              </v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "ManageOwner",
  data() {
    return {
      validForm: false,
    };
  },
  computed: {
    ...mapState(["lang", "ownerInfo", "snackbar", "ownersResults"]),
    ...mapGetters(["rules"]),
    passwordConfirmationRule() {
      return [
        (value) =>
          !!value || (this.lang == "en" ? "Required" : "Obavezno polje"),
        this.password.new === this.password.newConfirm ||
          (this.lang == "en"
            ? "New passwords must match"
            : "Nove lozinke se moraju poklapati"),
      ];
    },
  },
  mounted() {
    this.setupForm();
  },
  methods: {
    setupForm() {
      var thisy = this
      if (this.$route.query.id) {
        var ownerObj = this.ownersResults.filter(owner => { return owner.ownerId == thisy.$route.query.id })
        ownerObj = ownerObj[0]
        this.$store.state.ownerInfo = {
          name: ownerObj.name,
          surname: ownerObj.surname,
          jmbg: ownerObj.jmbg,
          email: ownerObj.email,
          mobilePhone: ownerObj.mobilePhone,
          phone: ownerObj.phone,
          address: ownerObj.address,
          lk: ownerObj.lk
        };
      } else {
        this.$store.state.ownerInfo = {
          name: "",
          surname: "",
          jmbg: "",
          email: "",
          mobilePhone: "",
          phone: "",
          address: "",
          lk: "",
        };
      }
    },
    updateOwner() {
      this.$store.dispatch("updateOwner", this.$route.query.id);
    },
    insertOwner() {
      this.$store.dispatch("insertOwner");
    },
    ManageOwner() {
      if (this.$refs.myInfoForm.validate()) {
        if (this.$route.query.id) {
          this.updateOwner();
        } else {
          this.insertOwner();
        }
        this.edit = false;
      }
    },
  },
  watch: {
    "$route.query"() {
      this.setupForm();
    },
  },
};
</script>

<style lang="scss">
.my-form-container-new-owner {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  > div:nth-child(1) {
    flex: 0 0 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      display: flex;
      flex: 0 0 49%;
    }
  }
}

@media (max-width: 768px) {
  .my-form-container-new-owner {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  > div:nth-child(1) {
    flex: 0 0 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      display: flex;
      flex: 0 0 100%!important;
    }
  }
}
}
</style>